"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogPage = void 0;
var _SanitizeHtml = require("./SanitizeHtml");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DialogPage = ({
  html
}) => html && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DialogContentStyled, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SanitizeHtml.SanitizeHtml, {
    html: html
  })
});
exports.DialogPage = DialogPage;
